import React, { FC } from "react";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";

interface trialToricPowersProp {
  left_boxes?: number | any;
  right_boxes?: number | any;
  left_sph?: string;
  left_cyl?: string;
  left_axis?: string;
  right_sph?: string;
  right_cyl?: string;
  right_axis?: string;
  price?: string | any;
  temp_cart_id?: number | any;
  cart_id: number | any;
  variant_id: number | any;
  right?: boolean | any;
  left?: boolean | any;
  power_type?:string
  compare_at_price?:string | any;
}

export const TrialToricPowers = (props: trialToricPowersProp) => {
  const { updateCartItem } = useShoppingCart();

  // console.log(
  //   parseInt(props.left_boxes),
  //   parseInt(props.right_boxes),
  //   "satyatau"
  // );
  let quantity = 0;
  if (
   props.left_boxes === undefined ||
    props.left_boxes === null
  ) {
    quantity = parseInt(props.right_boxes);
  } else if (
   props.right_boxes === undefined ||
    props.right_boxes === null
  ) {
    quantity = parseInt(props.left_boxes);
  } else {
    quantity = parseInt(props.left_boxes) + parseInt(props.right_boxes);
  }

  const increaseQuantityLeft = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: quantity + 1,
    prescription: {
      powerType: "CONTACT_LENS",
      ...(props.left === true && {
        left: {
          boxes: parseInt(props.left_boxes) + 1,
          sph: props.left_sph,
          cyl: props.left_cyl,
          axis: props.left_axis,
        },
      }),
      ...(props.right === true && {
        right: {
          boxes: parseInt(props.right_boxes),
          sph: props.right_sph,
          cyl: props.right_cyl,
          axis: props.right_axis,
        },
      }),
    },
  };

  const decreaseQuantityLeft = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: quantity - 1,
    prescription: {
      powerType: "CONTACT_LENS",
      ...(props.left === true && {
        left: {
          boxes: parseInt(props.left_boxes) - 1,
          sph: props.left_sph,
          cyl: props.left_cyl,
          axis: props.left_axis,
        },
      }),
      ...(props.right === true && {
        right: {
          boxes: parseInt(props.right_boxes),
          sph: props.right_sph,
          cyl: props.right_cyl,
          axis: props.right_axis,
        },
      }),
    },
  };

  const increaseQuantityRight = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: quantity + 1,
    prescription: {
      powerType: "CONTACT_LENS",
      ...(props.left === true && {
        left: {
          boxes: parseInt(props.left_boxes),
          sph: props.left_sph,
          cyl: props.left_cyl,
          axis: props.left_axis,
        },
      }),
      ...(props.right === true && {
        right: {
          boxes: parseInt(props.right_boxes) + 1,
          sph: props.right_sph,
          cyl: props.right_cyl,
          axis: props.right_axis,
        },
      }),
    },
  };

  const decreaseQuantityRight = {
    cart_id: props.cart_id,
    cart_item_id: props.temp_cart_id,
    quantity: quantity - 1,
    prescription: {
      powerType: "CONTACT_LENS",
      ...(props.left === true && {
        left: {
          boxes: parseInt(props.left_boxes),
          sph: props.left_sph,
          cyl: props.left_cyl,
          axis: props.left_axis,
        },
      }),
      ...(props.right === true && {
        right: {
          boxes: parseInt(props.right_boxes) - 1,
          sph: props.right_sph,
          cyl: props.right_cyl,
          axis: props.right_axis,
        },
      }),
    },
  };

  return (
    <>
      <div className="powerWrappers">
        {props.left_sph && (
          <div className="leftPowerWrapper">
            <div className="quantityItem">
              <div className="eyeSpecs">
                <span className="eyeHeading">Left Eye : </span>{" "}
                <span className="quantityCountTrial">
                  
                  {parseInt(props.left_boxes)}
                 
                </span>
              </div>
              <div className="itemPrice">
              {/* <span className="itemPriceCompare">Rs. 300 </span> */}
              <span className="itemPriceCompare">Rs. {props.compare_at_price * parseInt(props.left_boxes)} </span>
              <span className="itemPriceSelling">Rs. {props.price * parseInt(props.left_boxes)}</span>

              </div>
            </div>

            <div className="leftPowers powersData">
              {props.left_sph.includes("/") && props.left_cyl && props.left_axis  ? (
                <>
                  <span className="powersHeading">SPH:</span>
                  <span className="powers">{props.left_sph.split('/')[0].trim()}</span>
                  <span className="separator"></span>
                  <span className="powersHeading">CYL:</span>
                  <span className="powers">{props.left_cyl.split('/')[0].trim()}</span>
                  <span className="separator"></span>
                  <span className="powersHeading">Axis:</span>
                  <span className="powers">{props.left_axis.split('/')[0].trim()}</span>
                </>
              ) : (
                <>
                  <span className="powersHeading">SPH:</span>
                  <span className="powers">{props.left_sph}</span>
                  <span className="separator"></span>
                  <span className="powersHeading">CYL:</span>
                  <span className="powers">{props.left_cyl && props.left_cyl}</span>
                  <span className="separator"></span>
                  <span className="powersHeading">Axis:</span>
                  <span className="powers">{props.left_axis && props.left_axis}</span>
                </>
              )}
            </div>
          </div>
        )}
        {props.right_sph && (
          <div className="rightPowerWrapper">
            <div className="quantityItem">
              <div className="eyeSpecs ">
                <span className="eyeHeading">Right Eye : </span>
                <span className="quantityCountTrial">
                  
                  {parseInt(props.right_boxes)}
                  
                </span>
              </div>
              <div className="itemPrice">
                <span className="itemPriceCompare">Rs. {props.compare_at_price * parseInt(props.right_boxes)}</span>
              {/* <span className="itemPriceCompare">Rs. 300 </span> */}
                <span className="itemPriceSelling">Rs. {props.price * parseInt(props.right_boxes)}</span>
              </div>
            </div>
            <div className="rightPowers powersData">
            {props.right_sph.includes("/") && props.right_cyl && props.right_axis ? (

<>
              <span className="powersHeading">SPH:</span>{" "}
              <span className="powers">{props.right_sph.split('/')[0].trim()}</span>{" "}
              <span className="separator"></span>
              <span className="powersHeading">CYL:</span>{" "}
              <span className="powers">{props.right_cyl.split('/')[0].trim()}</span>{" "}
              <span className="separator"></span>
              <span className="powersHeading">Axis:</span>
              <span className="powers">{props.right_axis.split('/')[0].trim()}</span>
              </>
            ):(
              <>
              <span className="powersHeading">SPH:</span>{" "}
              <span className="powers">{props.right_sph}</span>{" "}
              <span className="separator"></span>
              <span className="powersHeading">CYL:</span>{" "}
              <span className="powers">{props.right_cyl}</span>{" "}
              <span className="separator"></span>
              <span className="powersHeading">Axis:</span>
              <span className="powers">{props.right_axis}</span>
              </>

            )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
